import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiTerminalsRegistrationsIdOtpService(id) {
  return fetch(`terminals/registrations/${id}/otp`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
